import React from 'react';
import { Image } from 'react-konva';
import useImage from 'use-image';

import icon_delete from '../../../assets/images/icon_delete.svg';

const DeleteDiagram = ({
    x,
    y,
    numberKey,
    setNumberKey,
    setShow,
    setDelete,
  }) => {
    const [image] = useImage(icon_delete);
    const showDeleteDiagram = async () => {
      await setNumberKey(numberKey);
      setShow(true);
      setDelete(true);
    };
    return (
      <Image
        x={x}
        y={y}
        width={20}
        height={20}
        image={image}
        onClick={showDeleteDiagram}
      />
    );
  };

export default DeleteDiagram;